// extracted by mini-css-extract-plugin
export default {"Single":"Single_Single__FAr0K","Single_Winner":"Single_Single_Winner__IEKEQ","Single_Tiles":"Single_Single_Tiles__JFQt4"};